<template>
  <v-dialog :value="$store.getters['estimates/manageEstimateDialog']" fullscreen>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn @click="closeDialog" icon dark>
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Manage Estimate</v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <v-btn :loading="isLoading" :disabled="isLoading" @click="processDraft" dark text>Save Draft</v-btn>
          <v-btn :loading="isLoading" :disabled="isLoading" @click="processEstimate" dark text>Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col v-if="editInOldSystem" cols="12">
              <v-alert class="white--text" color="error">EDIT IN OLD SYSTEM</v-alert>
            </v-col>
            <v-col cols="12">
              <estimate-canvas :isEditable="true" :estimate="estimate"/>
              <v-divider class="mt-3"/>
              <v-tabs vertical v-model="tab">
                <v-tab>
                  <v-icon left>mdi-account</v-icon>
                  Customer
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-image-broken-variant</v-icon>
                  Damage
                </v-tab>
                <v-tab class="text-left">
                  <v-icon left>mdi-account-tie</v-icon>
                  Contractors
                </v-tab>
                <v-tab class="text-left">
                  <v-icon left>mdi-car</v-icon>
                  Courtesy Car
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-tools</v-icon>
                  Parts
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-account-card-details</v-icon>
                  Details
                </v-tab>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-customer :estimate="estimate"/>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-damage :estimate="estimate"/>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-contractors :estimate="estimate"/>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-courtesy-car :estimate="estimate"/>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-parts :estimate="estimate"/>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <estimate-details :estimate="estimate" v-on:sub-estimates-updated="updateTotals"/>
                      <v-data-table v-if="renderComponent && (estimate.subEstimates && estimate.subEstimates.length > 0)" :items="estimate.subEstimates" :headers="subHeaders">
                        <template v-slot:item.actions="{item}">
                          <v-icon large color="error" @click="deleteItem(item)">mdi-delete</v-icon>
                        </template>
                      </v-data-table>
                      <v-btn class="mt-2" :loading="isLoading" :disabled="isLoading" @click="processDraft"
                             color="success">Save Draft
                      </v-btn>
                      <v-btn class="mt-2 ml-3" :loading="isLoading" :disabled="isLoading" @click="processEstimate"
                             color="primary">Save Estimate
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EstimateCanvas from "./sections/EstimateCanvas";
import EstimateCustomer from "./sections/EstimateCustomer";
import {EventBus} from "../../../EventBus";
import EstimateDamage from "./sections/EstimateDamage";
import EstimateContractors from "./sections/EstimateContractors";
import EstimateCourtesyCar from "./sections/EstimateCourtesyCar";
import EstimateParts from "./sections/EstimateParts";
import EstimateDetails from "./sections/EstimateDetails";
import {EstimatesHttp} from "../../../http/estimates";
import {toAmount} from "../../../helper/amount";

export default {
  name: "EstimateDialog",
  components: {
    EstimateDetails,
    EstimateParts,
    EstimateCourtesyCar, EstimateContractors, EstimateDamage, EstimateCustomer, EstimateCanvas
  },
  mounted() {
    EventBus.$on('estimate-customer-selected', () => {
      if (this.estimate.customer.name) {
        this.tab = 1;
      }
    });

    EventBus.$on('estimate-damage-selected', () => {
      this.tab = 2;
      this.updateTotals();
    });

    EventBus.$on('estimate-part-added', part => {
      if (!this.estimate.parts) {
        this.estimate.parts = [];
      }
      this.estimate.parts.push(part);
      this.updateTotals();
    });

    EventBus.$on('estimate-part-removed', name => {
      this.estimate.parts.splice(this.estimate.parts.findIndex(x => x.name === name), 1);
      this.updateTotals();
    });
  },
  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    async closeDialog() {
      this.tab = 0;
      this.editInOldSystem = false;
      /* eslint-disable no-alert, no-console */
      console.log('Firing');
      EventBus.$emit('estimate-reset');
      await this.$store.dispatch('estimates/resetActiveEstimate');
      await this.$store.dispatch('estimates/setEstimates');
      await this.$store.dispatch('estimates/setDrafts');
      await this.$store.dispatch('estimates/setManageEstimateDialog', false);
    },
    processEstimate() {
      this.estimate._id ? this.saveEstimate() : this.createEstimate();
    },
    validateEstimate() {
      if (this.estimate.customer && this.estimate.customer.name && this.estimate.total) {
        return true;
      }
    },
    async processDraft() {
      this.estimate._id ? await this.saveDraft() : await this.createDraft();
    },
    async saveDraft() {
      this.isLoading = true;
      try {
        this.estimate.isDraft = true;
        await EstimatesHttp.updateExistingEstimate(this.estimate._id, this.estimate);
        EventBus.$emit('message', {message: 'Estimate Saved Successfully', type: 'success'});
        await this.$store.dispatch('estimates/resetActiveEstimate');
        await this.$store.dispatch('estimates/setEstimates');
        await this.$store.dispatch('estimates/setDrafts');
        await this.closeDialog();
      } catch (e) {
        EventBus.$emit('message', {message: e, type: 'error'});
      } finally {
        this.isLoading = false;
      }
    },
    async createDraft() {
      this.isLoading = true;
      try {
        this.estimate.isDraft = true;
        await EstimatesHttp.createNewEstimate(this.estimate);
        EventBus.$emit('message', {message: 'Estimate Created Successfully', type: 'success'});
        await this.$store.dispatch('estimates/resetActiveEstimate');
        await this.$store.dispatch('estimates/setEstimates');
        await this.$store.dispatch('estimates/setDrafts');
        await this.closeDialog();
      } catch (e) {
        EventBus.$emit('message', {message: e, type: 'error'});
      } finally {
        this.isLoading = false;
      }
    },
    async saveEstimate() {
      if (this.validateEstimate()) {
        this.isLoading = true;
        try {
          this.estimate.isDraft = null;
          await EstimatesHttp.updateExistingEstimate(this.estimate._id, this.estimate);
          EventBus.$emit('message', {message: 'Estimate Saved Successfully', type: 'success'});
          await this.$store.dispatch('estimates/resetActiveEstimate');
          await this.$store.dispatch('estimates/setEstimates');
          await this.$store.dispatch('estimates/setDrafts');
          await this.closeDialog();
        } catch (e) {
          EventBus.$emit('message', {message: e, type: 'error'});
        } finally {
          this.isLoading = false;
        }
      }
    },
    async createEstimate() {
      if (this.validateEstimate()) {
        this.isLoading = true;
        try {
          this.estimate.isDraft = null;
          await EstimatesHttp.createNewEstimate(this.estimate);
          EventBus.$emit('message', {message: 'Estimate Created Successfully', type: 'success'});
          await this.$store.dispatch('estimates/resetActiveEstimate');
          await this.$store.dispatch('estimates/setEstimates');
          await this.$store.dispatch('estimates/setDrafts');
          await this.closeDialog();
        } catch (e) {
          EventBus.$emit('message', {message: e, type: 'error'});
        } finally {
          this.isLoading = false;
        }
      }
    },
    updateTotals(se) {
      this.estimate.total = 0;
      if (this.estimate.damage) {
        this.estimate.damage.forEach(damage => {
          this.estimate.total = this.estimate.total + toAmount(damage.labour);
        });
      }
      if (this.estimate.parts) {
        this.estimate.parts.forEach(part => {
          this.estimate.total = this.estimate.total + toAmount(part.price);
        });
      }
      if (se && se.length > 0) {
        this.estimate.subEstimates = [...se];
        this.forceRerender();
      }
      this.forceRerender();
    },
    deleteItem(sub) {
      const index = this.estimate.subEstimates.findIndex(x => x.name === sub.name);
      this.estimate.subEstimates.splice(index, 1);
      this.forceRerender();
    }
  },
  data() {
    return {
      isLoading: false,
      tab: null,
      editInOldSystem: false,
      renderComponent: true,
      subHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Notes', value: 'notes' },
        { text: 'Total', value: 'total' },
        { text: 'Actions', value: 'actions' }
      ]
    }
  },
  computed: {
    estimate: {
      get() {
        return this.$store.state.estimates.activeEstimate;
      }
    }
  },
  watch: {
    estimate: {
      handler(newVal) {
        if (newVal.damage && newVal._id) {
          newVal.damage.forEach(d => {
            this.editInOldSystem = !d.repairDetail;
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
